import { render, staticRenderFns } from "./integral-detail.vue?vue&type=template&id=3be59085&scoped=true&"
import script from "./integral-detail.vue?vue&type=script&lang=js&"
export * from "./integral-detail.vue?vue&type=script&lang=js&"
import style0 from "./integral-detail.scss?vue&type=style&index=0&id=3be59085&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3be59085",
  null
  
)

export default component.exports